import styled from "styled-components"
import { themeChangeTime } from "../../styles/global";

interface CircularChartProps {
  size: string;
}
export const CircularChart = styled.svg<CircularChartProps>`
    display: block;
    margin: 10px auto;

    width: ${props => props.size};
    height: ${props => props.size};
`;

export const CircleBg = styled.path`
  fill: none;
  stroke: ${(props) => props.theme.circularPercentage};
  transition: all ${themeChangeTime};
  stroke-width: 3.8;
`;

interface CircleProps{
  percentage: string;
  d: any;
}
export const Circle = styled.path<CircleProps>`
  fill: none;
  stroke-width: 2.8;
  stroke-linecap: round;
  stroke: #3c9ee5;

  stroke-dasharray: ${props => props.percentage};

  transition: stroke-dasharray 2s;
`;

export const Percentage = styled.text`
  fill: #666;
  font-family: sans-serif;
  font-size: 0.5em;
  text-anchor: middle;
`;
